import { UzBadge } from '@utazzo/ui';
import React from 'react';

import { agoLabel, money } from '../booking-format';
import { ProductTabs } from '../components/ProductTabs';
import { useTravelBookingsSummary } from '../use-travel-bookings';

import { PageShell } from '@/components/page-shell';

/**
 * Ticketing > Action needed.
 *
 * The queue of website bookings that need, or had, an admin's hand: on hold
 * by default - paid, refused by the supplier for our account, waiting for a
 * top-up and a click or a refund - with the view filter opening it up to
 * what admins already confirmed, cancelled or refunded. Nothing here expires
 * on its own: a hold waits until someone decides, and the badge in the
 * sidebar keeps counting until they do.
 */
export const TicketingActionPage = (): React.JSX.Element => {
  const summary = useTravelBookingsSummary();
  const s = summary.data;
  const held = s?.actionNeeded ?? 0;

  return (
    <PageShell
      title="Action needed"
      description="Website bookings waiting on a decision. Book now once the supplier wallet is topped up, or refund. Switch the view to see what admins already handled."
      actions={
        s ? (
          <div className="flex flex-wrap items-center gap-2 text-xs text-zinc-600 max-sm:w-[calc(100vw-2rem)]">
            <UzBadge tone={held > 0 ? 'warning' : 'secondary'} dot={held > 0}>
              {held} on hold
            </UzBadge>
            {held > 0 && (
              <span>
                {money(s.heldPaise, s.currencyCode)} of guest money
                {s.oldestHoldSince ? ` · longest wait ${agoLabel(s.oldestHoldSince)}` : ''}
              </span>
            )}
            <span className="hidden sm:inline">
              · {s.confirmedToday} confirmed today · {s.failedToday} failed
            </span>
          </div>
        ) : null
      }
    >
      <ProductTabs variant="action" gridIdPrefix="ticketing-action" allCount={held} />
    </PageShell>
  );
};
